import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import CustomHeader from "./CustomHeader";
import "../../style/sidebar.css";

const Layout = ({ children, onHeaderNavigation }) => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const [activeLabel, setActiveLabel] = useState("products");

  // Auto-set activeLabel based on current path
  useEffect(() => {
    if (location.pathname === "/customers" || location.pathname.startsWith("/customer/")) {
      setActiveLabel("customers");
    } else if (location.pathname === "/products" || location.pathname.startsWith("/product/")) {
      setActiveLabel("products");
    } else if (location.pathname === "/brands") {
      setActiveLabel("brands");
    } else if (location.pathname === "/category") {
      setActiveLabel("categories");
    } else if (location.pathname === "/batches") {
      setActiveLabel("batches");
    } else if (location.pathname === "/purchases") {
      setActiveLabel("purchases");
    } else if (location.pathname === "/low-stock") {
      setActiveLabel("low-stock");
    } else if (location.pathname === "/finance" || location.pathname.startsWith("/finance/")) {
      if (
        location.pathname === "/finance/journal" ||
        location.pathname === "/finance/journal/daily-report/print"
      ) {
        setActiveLabel("journal");
      } else if (
        location.pathname === "/finance/reports" ||
        location.pathname === "/finance/reports/due-customers/print" ||
        location.pathname === "/finance/reports/customers-overview/print"
      ) {
        setActiveLabel("reports");
      } else {
        setActiveLabel("journal"); // Default to journal when on /finance
      }
    } else if (location.pathname.startsWith("/returns")) {
      if (location.pathname === "/returns/register") {
        setActiveLabel("register");
      } else if (location.pathname === "/returns/repair-reserve") {
        setActiveLabel("repair-reserve");
      } else if (
        location.pathname === "/returns/vendor" ||
        location.pathname.startsWith("/returns/vendor/")
      ) {
        setActiveLabel("vendor-returns");
      } else {
        setActiveLabel("register"); // Default to register when on /returns
      }
    }
  }, [location.pathname]);

  // 👇 Define header labels (you can adjust these as needed)
  const headerLabels = [
    { label: "Products", value: "products" },
    { label: "Brands", value: "brands" },
    { label: "Categories", value: "categories" },
    { label: "Batches", value: "batches" },
    { label: "Purchases", value: "purchases" },
    { label: "Low Stock", value: "low-stock" },
  ];

  const customerHeaderLabels = [
    { label: "Customers", value: "customers" },
  ];

  const financeHeaderLabels = [
    { label: "Journal", value: "journal" },
    { label: "Reports", value: "reports" },
  ];

  const returnsHeaderLabels = [
    { label: "Register", value: "register" },
    { label: "Repair Reserve", value: "repair-reserve" },
    { label: "Supplier Returns", value: "vendor-returns" },
  ];

  return (
    <div className="d-flex vh-100 bg-light">
      {/* Mobile Menu Button */}
      <button
        className="d-md-none btn btn-light position-fixed"
        style={{ top: "10px", left: "10px", zIndex: 1050 }}
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      >
        ☰
      </button>

      {/* Sidebar */}
      <Sidebar 
        isMobileMenuOpen={isMobileMenuOpen} 
        setIsMobileMenuOpen={setIsMobileMenuOpen}
        onCollapseChange={setIsSidebarCollapsed}
      />

      {/* Main Content */}
      <div className={`flex-fill d-flex flex-column main-content ${isSidebarCollapsed ? 'sidebar-collapsed' : 'sidebar-open'} ${
        location.pathname === "/pos" ? "" : "overflow-auto no-scrollbar"
      }`}>
        {/* Custom Header */}
        <CustomHeader
          headerLabels={
            (location.pathname === "/products" || location.pathname.startsWith("/product/") || 
             location.pathname === "/brands" || location.pathname === "/category" || 
             location.pathname === "/batches" || location.pathname === "/purchases" || 
             location.pathname === "/low-stock") ? headerLabels :
            (location.pathname === "/customers" || location.pathname.startsWith("/customer/")) ? customerHeaderLabels :
            (location.pathname === "/finance" || location.pathname.startsWith("/finance/")) ? financeHeaderLabels :
            (location.pathname.startsWith("/returns")) ? returnsHeaderLabels :
            []
          }
          activeLabel={activeLabel}
          setActiveLabel={setActiveLabel}
          onHeaderNavigation={onHeaderNavigation}
        />

        {/* Main Area */}
        <main
          className="flex-fill p-3"
          style={{ marginTop: "1rem" }}
        >
          {/* 👇 Pass activeLabel + setActiveLabel to child */}
          {React.cloneElement(children, { activeLabel, setActiveLabel })}
        </main>
      </div>
    </div>
  );
};

export default Layout;
